import React, { useState, useEffect } from 'react';
import { FiStar, FiMessageCircle, FiChevronLeft, FiChevronRight } from 'react-icons/fi';

export default function Testimonials() {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const testimonials = [
    {
      id: 1,
      title: "Love the Custom Option",
      name: "Hannah F.",
      location: "Hamburg, Germany",
      rating: 5,
      text: "I'm so happy I found this shop. The dress is gorgeous, fits wonderfully, and looks exactly like the pictures. Customer service was amazing and very supportive"
    },
    {
      id: 2,
      title: "Love it so much",
      name: "Katrin H.",
      location: "Munich, Germany",
      rating: 5,
      text: "I'm very happy with my purchase. The dress is even better in person, and receiving a small jewelry gift was such a sweet surprise"
    },
    {
      id: 3,
      title: "Excellent value and service!",
      name: "Tracy",
      location: "Hawaii, USA",
      rating: 5,
      text: "The dress is beautiful and exactly like the photos. It fits perfectly! The quality is fabulous. The customer service was excellent from start to finish. I would definitely buy more dresses from here."
    },
    {
      id: 4,
      title: "Incredible Quality",
      name: "Charlotte D.",
      location: "Lyon, France",
      rating: 5,
      text: "Honestly, this is one of the best purchases I've made. The dress is prettier in person and the quality is fine. Customer support answered my questions quickly"
    },
    {
      id: 5,
      title: "Love it so much",
      name: "Mr. Laura H.",
      location: "New Jersey, USA",
      rating: 5,
      text: "As a dance teacher, I am always looking for quality costumes for my students. This dress is beautifully made, fits perfectly and moves wonderfully on stage. The extra jewelry gift was such a thoughtful surprise"
    },
    {
      id: 6,
      title: "Classic and Classy",
      name: "Chloe M.",
      location: "Manchester, UK",
      rating: 5,
      text: "Beautifully made and true to the photos. The size chart was accurate, so it fit me without any adjustments. I will definitely come back for more designs."
    },
    {
      id: 7,
      title: "Stylish and Comfortable",
      name: "Madison K.",
      location: "Chicago, USA",
      rating: 5,
      text: "I'm amazed by the detail in this dress—it's just gorgeous. The quality is better than many dresses I've bought in stores. It arrived on time and in perfect condition"
    }
  ];

  const itemsPerSlide = 3;
  const totalSlides = Math.ceil(testimonials.length / itemsPerSlide);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
  };

  // Auto-slide functionality
  useEffect(() => {
    const interval = setInterval(nextSlide, 5000); // Change slide every 5 seconds
    return () => clearInterval(interval);
  }, [totalSlides]);

  const getCurrentTestimonials = () => {
    const startIndex = currentSlide * itemsPerSlide;
    return testimonials.slice(startIndex, startIndex + itemsPerSlide);
  };

  return (
    <section className="py-12 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-3" style={{ fontFamily: 'serif' }}>
            What Our Dancers Say
          </h2>
          <p className="text-gray-400 text-sm max-w-3xl mx-auto">
            Don't just take our word for it. Here's what dancers, instructors, and parents have to say about Bailebelle.
          </p>
        </div>

        {/* Slider Container */}
        <div className="relative">
          {/* Navigation Buttons */}
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 transform -translate-y-1/2 z-10 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full transition-all duration-300 hover:scale-110"
            aria-label="Previous testimonials"
          >
            <FiChevronLeft className="w-6 h-6" />
          </button>
          
          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 transform -translate-y-1/2 z-10 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full transition-all duration-300 hover:scale-110"
            aria-label="Next testimonials"
          >
            <FiChevronRight className="w-6 h-6" />
          </button>

          {/* Testimonials Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 px-12">
            {getCurrentTestimonials().map((testimonial) => (
              <div
                key={testimonial.id}
                className="bg-gradient-to-br from-gray-900/80 to-gray-800/60 backdrop-blur-sm border border-gray-700/50 rounded-3xl p-8 hover:from-gray-900/90 hover:to-gray-800/70 transition-all duration-500 hover:scale-[1.02] hover:shadow-2xl hover:shadow-pink-500/20 group"
              >
                {/* Stars */}
                <div className="flex items-center mb-6">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <FiStar
                      key={i}
                      className="w-5 h-5 text-yellow-400 fill-current drop-shadow-sm"
                    />
                  ))}
                </div>

                {/* Title */}
                <h3 className="text-xl font-bold text-white mb-5 group-hover:text-pink-300 transition-colors duration-300">
                  {testimonial.title}
                </h3>

                {/* Testimonial Text */}
                <div className="relative mb-8">
                  
                  <p className="text-gray-300 leading-relaxed text-sm pl-2">
                    "{testimonial.text}"
                  </p>
                </div>

                {/* Customer Info */}
                <div className="text-right border-t border-gray-700/50 pt-4">
                  <p className="text-pink-400 font-semibold text-sm mb-1">{testimonial.name}</p>
                  <p className="text-gray-500 text-xs">{testimonial.location}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Slide Indicators */}
        <div className="flex justify-center mt-8 space-x-2">
          {[...Array(totalSlides)].map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                index === currentSlide 
                  ? 'bg-pink-500 scale-125' 
                  : 'bg-gray-600 hover:bg-gray-500'
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>

        {/* Overall Rating */}
        <div className="text-center mt-12">
          <div className="inline-flex items-center space-x-2 bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-full px-6 py-3">
            <div className="flex items-center">
              {[...Array(5)].map((_, i) => (
                <FiStar
                  key={i}
                  className="w-5 h-5 text-yellow-400 fill-current"
                />
              ))}
            </div>
            <span className="text-white font-semibold">4.9/5</span>
            <span className="text-gray-400">from 500+ reviews</span>
          </div>
        </div>
      </div>
    </section>
  );
}
